module.exports = __webpack_public_path__ + "psycho.fb0c1e75.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/img/cinema/psycho.jpg
// module id = wYye
// module chunks = 0